module.exports = "textarea {\n    resize: vertical;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/client/requestProcedure/requestProcedure.component.css
 ** module id = 1119
 ** module chunks = 0
 **/